'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDecisionMakerFormAttributes = exports.getPqlFormAttributes = undefined;

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

var _formAttributes = require('ui-addon-upgrades/_core/pql/formAttributes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPqlFormAttributes = exports.getPqlFormAttributes = function getPqlFormAttributes() {
  var isProd = _enviro2.default.getShort() === 'prod';

  if (!isProd) {
    return _formAttributes.QA_PQL_FORM_ATTRIBUTES;
  }

  return _formAttributes.PRODUCTION_PQL_FORM_ATTRIBUTES;
};

var getDecisionMakerFormAttributes = exports.getDecisionMakerFormAttributes = function getDecisionMakerFormAttributes() {
  var isProd = _enviro2.default.getShort() === 'prod';

  if (!isProd) {
    return _formAttributes.QA_DECESION_MAKER_FORM_ATTRIBUTES;
  }

  return _formAttributes.PROD_DECESION_MAKER_FORM_ATTRIBUTES;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/pql/getPqlFormAttributes.js
// module id = 533
// module chunks = 3 4 5